// extracted by mini-css-extract-plugin
export var avatar = "_rk-3";
export var avatarContainer = "_rk-2";
export var avatarSpacer = "_rk-5";
export var avatarSpacerContainer = "_rk-4";
export var avatarStackContainer = "_rk-1";
export var bubble = "_rk-0";
export var remainderBubble = "_rk-6";